import React, { useContext, useState, useEffect } from "react";
import OrderContext from "../../../../context/OrderContext";
import { useTranslation } from "react-i18next";
const OrderNav = () => {
  let {
    processed,
    setProcessed,
    setPage,
    clearFilters,
    searchParams,
    setSearchParams,
  } = useContext(OrderContext);
  function handlefilterProcess(event) {
    clearFilters();
    setPage(1);
    searchParams.set("vendor_aware_status", event);
    setProcessed(event);
    searchParams.set("page", "1");
    setPage(1);
    setSearchParams(searchParams.toString());
  }

  const [t, i18n] = useTranslation("common");

  const [statusFilter, setStatusFilter] = useState("");
  useEffect(() => {
    const param = searchParams.get("vendor_aware_status");
    setStatusFilter(param);
  }, [clearFilters]);

  return (
    <ul className="tab-nav">
      <li
        className={`${
          statusFilter === "" || statusFilter == "awaiting" ? "active" : ""
        }`}
      >
        <span onClick={() => handlefilterProcess("awaiting")}>Awaiting</span>
      </li>
      <li className={`${statusFilter === "accepted" ? "active" : ""}`}>
        <span onClick={() => handlefilterProcess("accepted")}>Accepted</span>
      </li>
      <li className={`${statusFilter === "completed" ? "active" : ""}`}>
        <span onClick={() => handlefilterProcess("completed")}>Completed</span>
      </li>
      <li className={`${statusFilter === "rejected" ? "active" : ""}`}>
        <span onClick={() => handlefilterProcess("rejected")}>
          Out of stock
        </span>
      </li>
      <li className={`${statusFilter === "canceled" ? "active" : ""}`}>
        <span onClick={() => handlefilterProcess("canceled")}>Canceled</span>
      </li>
    </ul>
  );
};

export default OrderNav;
